import React, { useEffect, useState } from "react";
import { Badge } from "@component/badge";
import { Input } from "@component/input";
import { PlusIcon, X } from "lucide-react";
import SkillBadge from "@component/skill-badge";

interface Props {
  isEditing: boolean;
  isDisabled: boolean;
  data: string[];
  onChange: (values: string[]) => void;
}

export function Skills(props: Props) {
  const [skills, setSkill] = useState<string[]>([]);
  const [newSkill, setNewSkill] = useState("");

  useEffect(() => {
    setSkill(props.data);
  }, []);

  useEffect(() => {
    props.onChange(skills);
  }, [skills]);

  const addSkill = () => {
    if (newSkill.trim()) {
      const updatedCategories = [...skills];
      updatedCategories.push(newSkill.trim());
      setSkill(updatedCategories);
      setNewSkill("");
    }
  };

  const removeSkill = (index: number) => {
    const updatedCategories = [...skills];
    updatedCategories.splice(index, 1);
    setSkill(updatedCategories);
  };

  return (
    <div className="space-y-6">
      {props.isEditing ? (
        <div className="space-y-4">
          <div className="flex flex-wrap gap-2">
            {skills.map((skill, i) => (
              <span key={i} className="bg-blue-100  text-blue-800 px-3 py-1 rounded-full text-xs">
                {skill}
                <button
                  onClick={() => removeSkill(i)}
                  className="p-0.5 rounded-full hover:bg-blue-200 ml-1"
                  title="Remove skill"
                >
                  <X className="h-3 w-3" />
                </button>
              </span>
            ))}
          </div>
          <div className="flex flex-col sm:flex-row gap-2">
            <Input
              value={newSkill}
              onChange={(e) => setNewSkill(e.target.value)}
              placeholder="Add a new skill"
              className="border-gray-300 text-gray-900 flex-1"
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  addSkill();
                }
              }}
            />
            <button
              onClick={addSkill}
              className="px-2 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center text-sm"
            >
              <PlusIcon className="h-4 w-4 mr-1" />
              Add
            </button>
          </div>
        </div>
      ) : (
        <div className="p-6">
          <div className="flex flex-wrap gap-2">
            {props.data.map((skill, i) => (
              <SkillBadge
                key={i}
                label={skill}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
